import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h2 className="text-2xl font-bold mb-2" style={{ color: '#B89A4E' }}>
              BROWN & ASSOCIATES
            </h2>
            <p className="text-gray-400 mb-4">
              Woman-Owned Accounting & Advisory Firm
            </p>
            <p className="text-gray-400 text-sm">
              Helping small businesses make sense of their numbers for over 30 years
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-bold mb-4" style={{ color: '#B89A4E' }}>Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#B89A4E] transition">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#B89A4E] transition">
                  About
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-[#B89A4E] transition">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/schedule" className="text-gray-400 hover:text-[#B89A4E] transition">
                  Schedule
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold mb-4" style={{ color: '#B89A4E' }}>Contact</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>
                <a href="mailto:joedec.brown@gmail.com" className="hover:text-[#B89A4E] transition">
                  joedec.brown@gmail.com
                </a>
              </li>
              <li>
                <a href="tel:6452203641" className="hover:text-[#B89A4E] transition">
                  645-220-3641
                </a>
              </li>
              <li>
                <a href="https://www.calendly.com/joede1123" target="_blank" rel="noopener noreferrer" className="hover:text-[#B89A4E] transition">
                  Schedule Online
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © 2025 Brown & Associates, LLC. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
